/*==================================================
HERSHOP CONTACT
==================================================*/

document.addEventListener("DOMContentLoaded", () => {

    const section = document.querySelector(".hershop-contact");

    if (!section) return;

    /*==========================================
    Reveal Animation
    ==========================================*/

    const items = section.querySelectorAll(
        ".hershop-contact__card, .hershop-contact__cta"
    );

    const observer = new IntersectionObserver((entries) => {

        entries.forEach((entry) => {

            if (!entry.isIntersecting) return;

            entry.target.classList.add("is-visible");

            observer.unobserve(entry.target);

        });

    }, {

        threshold: .15

    });

    items.forEach((item) => {

        item.classList.remove("is-visible");

        observer.observe(item);

    });

    /*==========================================
    Magnetic Hover
    ==========================================*/

    const cards = section.querySelectorAll(".hershop-contact__card");

    cards.forEach((card) => {

        card.addEventListener("mousemove", (e) => {

            if (window.innerWidth < 992) return;

            const rect = card.getBoundingClientRect();

            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;

            const moveX = (x - rect.width / 2) / 18;
            const moveY = (y - rect.height / 2) / 18;

            card.style.transform =
                `translate(${moveX}px, ${moveY}px)`;

        });

        card.addEventListener("mouseleave", () => {

            card.style.transform = "";

        });

    });

    /*==========================================
    CTA Glow
    ==========================================*/

    const cta = section.querySelector(".hershop-contact__cta");

    if (cta) {

        cta.addEventListener("mousemove", (e) => {

            const rect = cta.getBoundingClientRect();

            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;

            cta.style.setProperty("--mouse-x", `${x}px`);
            cta.style.setProperty("--mouse-y", `${y}px`);

        });

    }

});